import { Outlet, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import BatchListing from "./admin/Batches";
import CalendarPage from "./admin/Calander";
import CollegeInventory from "./admin/Certificationtransfer";
import ImageManager from "./admin/changepass";
import HappyLearnersManager from "./admin/HappyLearners";
import SuccessStoryManager from "./admin/SuccessStory";
import CollegeList from "./admin/Collegelist";
import CreatePassword from "./admin/Createpass";
import CollegeStudentList from "./admin/Cstudentslist";
import EContentCourses from "./admin/Econtent";
import EnquiryLinkInfo from "./admin/enquiry";
import Enrollstu from "./admin/enrolledstu";
import LeadImportForm from "./admin/ImpLead";
import Profile from "./admin/Profile";
import StudentImport from "./admin/studentimport";
import StudentsTable from "./admin/studentstable";
import TargetConfiguration from "./admin/Target";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import PrivateRoute from "./components/PrivateRoute";
import Main from "./main";
import About from "./Pages/About";
import AdminPanel from "./Pages/admin";
import Courses from "./Pages/courses";
import EmployeeRegistration from "./Pages/employeee";
import Explore from "./Pages/Explore";
import Learning from "./Pages/learning";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import PublicCalendar from "./Pages/PublicCalendar";
import Placement from "./Pages/placement";
import StudentRegistration from "./Pages/student";
import Verify from "./Pages/Verify";

const App = () => {
  return (
    
   
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Public layout */}
        <Route element={<Layout/>}>
          <Route path="/" element={<Main />} />
          <Route path="/placement" element={<Placement />} />
          <Route path="/about" element={<About />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/learning" element={<Learning />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin-register" element={<Register />} /> 
          <Route path="/courses" element={<Courses />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/register" element={<StudentRegistration />} />
          <Route path="/create" element={<CreatePassword />} />
          <Route path="/employee" element={<EmployeeRegistration />} />
          <Route path="/calendar" element={<PublicCalendar />} />
          <Route path="/student" element={<StudentRegistration />} />


        </Route>

        {/* Protected Admin Panel */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        >
          {/* ✅ Child routes that render inside AdminPanel */}
          <Route path="profile" element={<Profile />} />
          <Route path="students" element={<StudentsTable />} />
          <Route path="impstudents" element={<Enrollstu />} />
          <Route path="impstu" element={<StudentImport />} />
          <Route path="importlead" element={<LeadImportForm />} />
          <Route path="enquiry" element={<EnquiryLinkInfo />} />
          <Route path="econtent" element={<EContentCourses />} />
          <Route path="collegelist" element={<CollegeList />} />
          <Route path="cstudentslist" element={<CollegeStudentList />} />
          <Route path="inventorycollege" element={<CollegeInventory />} />
          <Route path="batches" element={<BatchListing />} />
          <Route path="celander" element={<CalendarPage />} />
          <Route path="target" element={<TargetConfiguration />} />
          <Route path="changepass" element={<ImageManager />} />
          <Route path="successstory" element={<SuccessStoryManager />} />
          <Route path="happylearners" element={<HappyLearnersManager />} />




        </Route>
      </Routes>
    </Router>
  );
};

// Public Layout wrapper
const Layout = () => (
  <>
    <Navbar />
    <Outlet />
    <Footer />
  </>
);

export default App;
